export default {
  authorization_code: {
    'invalid authorization code': 'setting.integration.invalidAuthorizationCode'
  }
}